document.querySelectorAll('[data-article-experience]').forEach((layout)=>{
  const body=layout.querySelector('[data-article-body]');
  if(!body)return;

  const sectionNodes=(heading)=>{
    const nodes=[];
    let node=heading.nextElementSibling;
    while(node&&node.tagName!=='H2'&&node.tagName!=='HR'){
      nodes.push(node);
      node=node.nextElementSibling;
    }
    return nodes;
  };

  const intro=[];
  for(const node of body.children){
    if(node.tagName!=='P'||!node.textContent.trim()||node.querySelector('img'))break;
    intro.push(node);
    if(intro.length===2)break;
  }
  if(intro.length===2){
    const lead=document.createElement('div');
    lead.className='pd-article-lead';
    intro[0].before(lead);
    intro.forEach((paragraph)=>lead.append(paragraph));
  }

  body.querySelectorAll('img[src][width][height]').forEach((image)=>{
    const width=Number(image.getAttribute('width'));
    const height=Number(image.getAttribute('height'));
    if(width>0&&height>0)image.classList.add(width/height<.9?'pd-article-image--portrait':'pd-article-image--landscape');
  });

  [...body.querySelectorAll(':scope > h2')].forEach((heading)=>{
    const nodes=sectionNodes(heading);
    const normalized=heading.textContent.trim().toLowerCase();

    const pairs=[];
    nodes.forEach((node)=>{
      if(node.tagName!=='H3')return;
      const match=node.textContent.trim().match(/^(\d+)[.)]\s+/);
      const copy=node.nextElementSibling;
      if(match&&copy?.tagName==='P')pairs.push({heading:node,copy,number:match[1]});
    });
    if(pairs.length>=3){
      const process=document.createElement('div');
      process.className='pd-article-process';
      pairs[0].heading.before(process);
      pairs.forEach((pair)=>{
        const step=document.createElement('section');
        step.className='pd-article-step';
        const badge=document.createElement('span');
        badge.className='pd-article-step__number';
        badge.textContent=pair.number;
        const walker=document.createTreeWalker(pair.heading,NodeFilter.SHOW_TEXT);
        let titleText=walker.nextNode();
        while(titleText&&!/\d+[.)]/.test(titleText.nodeValue))titleText=walker.nextNode();
        if(titleText)titleText.nodeValue=titleText.nodeValue.replace(/^(\s*)\d+[.)]\s+/,'$1');
        pair.heading.prepend(badge);
        step.append(pair.heading,pair.copy);
        process.append(step);
      });
    }

    if(normalized.includes('photos work best')){
      const checklist=nodes.find((node)=>node.tagName==='P'&&node.textContent.includes('✔')&&node.querySelectorAll('br').length>=2);
      if(checklist){
        const lines=checklist.innerText.split(/\n+/).map((line)=>line.trim()).filter(Boolean);
        if(lines.length>=3){
          const list=document.createElement('ul');
          list.className='pd-article-checklist';
          lines.forEach((line)=>{const item=document.createElement('li');item.textContent=line.replace(/^✔\s*/,'');list.append(item)});
          checklist.replaceWith(list);
        }
      }
    }

    if(normalized.includes('size')&&normalized.includes('choose')){
      const recommendation=nodes.find((node)=>node.tagName==='P'&&node.textContent.includes('👉')&&node.querySelector('br'));
      if(recommendation){
        const lines=recommendation.innerText.split(/\n+/).map((line)=>line.trim()).filter(Boolean);
        if(lines.length>=2){
          const callout=document.createElement('aside');
          callout.className='pd-article-size-callout';
          callout.setAttribute('aria-label','Size recommendation');
          const label=document.createElement('strong');
          label.textContent='Recommended size';
          callout.append(label);
          lines.forEach((line)=>{const item=document.createElement('span');item.textContent=line.replace(/^👉\s*/,'');callout.append(item)});
          recommendation.replaceWith(callout);
        }
      }
    }

    if(normalized.includes('mistake')||normalized.includes('avoid')){
      heading.classList.add('pd-article-heading--caution');
      const list=nodes.find((node)=>node.matches('ul,ol'));
      if(list)list.classList.add('pd-article-caution-list');
    }

    if(normalized.includes('why choose')&&normalized.includes('kit')){
      const list=nodes.find((node)=>node.matches('ul,ol'));
      if(list)list.classList.add('pd-article-benefit-grid');
    }

    if(normalized.includes('create your')&&normalized.includes('today')){
      const conclusion=document.createElement('div');
      conclusion.className='pd-article-inline-cta';
      heading.before(conclusion);
      conclusion.append(heading,...nodes);
    }
  });

  const headings=[...body.querySelectorAll('h2')].filter((heading)=>!heading.closest('.pd-article-inline-cta'));
  if(headings.length<2)return;
  const used=new Set();
  const slug=(text)=>{
    const base=text.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')||'section';
    let value=base,index=2;
    while(used.has(value)||document.getElementById(value)){value=`${base}-${index++}`}
    used.add(value);
    return value;
  };
  headings.forEach((heading)=>{if(!heading.id)heading.id=slug(heading.textContent.trim())});
  layout.classList.add('has-toc');
  layout.querySelectorAll('[data-article-toc-links]').forEach((nav)=>{
    const list=document.createElement('ol');
    headings.forEach((heading)=>{const item=document.createElement('li');const link=document.createElement('a');link.href=`#${heading.id}`;link.textContent=heading.textContent.trim();item.append(link);list.append(item)});
    nav.append(list);
  });
  layout.querySelector('[data-article-toc]').hidden=false;
  layout.querySelector('[data-article-toc-mobile]').hidden=false;
});
